import type { RenderableTreeNodes } from '@markdoc/markdoc';
import Markdoc from '@markdoc/markdoc';
import type { GetStaticPaths, GetStaticProps } from 'next';
import React from 'react';
import {
  Callout,
  CodeBlock,
  CustomLink,
  ExcelTable,
  FileActions,
  Heading,
  Highlight,
  Mermaid,
  Spacer,
  Tab,
  Table,
  Tabs,
} from '../../components';
import { getAllSlugs, getMarkdocBySlug } from '../../lib/markdoc';
import type { NavSection } from '../../lib/navigation';
import { getNavigation } from '../../lib/navigation';
import type { SearchEntry } from '../../lib/search';
import { getSearchIndex } from '../../lib/search';

const components = {
  Callout,
  CodeBlock,
  Heading,
  CustomLink,
  Highlight,
  Mermaid,
  ExcelTable,
  FileActions,
  Spacer,
  Table,
  Tabs,
  Tab,
};

type MarkdocFrontmatter = {
  title?: string;
  description?: string;
  [key: string]: unknown;
};

type DocsPageProps = {
  markdoc: {
    content: RenderableTreeNodes;
    frontmatter: MarkdocFrontmatter;
  };
  navigation: NavSection[];
  searchIndex: SearchEntry[];
  slug: string[];
};

export default function DocsPage({ markdoc }: DocsPageProps) {
  const { content } = markdoc;

  return <article>{Markdoc.renderers.react(content, React, { components })}</article>;
}

export const getStaticPaths: GetStaticPaths = async () => {
  const slugs = getAllSlugs();

  const paths = slugs.map((slug) => ({
    params: { slug },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = (params?.slug as string[]) || [];
  const markdocFile = getMarkdocBySlug(slug);

  if (!markdocFile) {
    return {
      notFound: true,
    };
  }

  const navigation = getNavigation();
  const searchIndex = getSearchIndex();

  return {
    props: {
      markdoc: {
        content: JSON.parse(JSON.stringify(markdocFile.content)),
        frontmatter: markdocFile.frontmatter,
      },
      navigation,
      searchIndex,
      slug,
    },
  };
};
